import React from 'react';
import { cn } from '../ui';

export function CodeBlock({ code, lang = 'text', variant = 'default', showHeader = true, className }) {
  return (
    <div className={cn('overflow-hidden rounded-lg border border-border', className)}>
      {showHeader && (
        <div className="bg-muted px-3 py-1.5 text-xs font-medium text-muted-foreground">
          {lang}
        </div>
      )}
      <pre className="bg-muted/50 p-4 overflow-x-auto text-sm">
        <code className="text-foreground">{code}</code>
      </pre>
    </div>
  );
}
